import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {SelectUserOptions} from "./options/select-user.options";
import {FilterUtil} from "../../../util/filter.util";
import {MatDialogRef} from "@angular/material/dialog";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {RequestType} from "../../../enums/request.type";

@Component({
  selector: 'app-select-user',
  standalone: false,
  templateUrl: './select-user.component.html',
  styleUrls: ['./select-user.component.scss']
})
export class SelectUserComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Choose', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email'];
  displayDataSources = ['touch_app', 'FirstName', 'LastName', 'NationalCode', 'MobileNumber', 'Email'];
  displayColumnTypes = ['event', 'string', 'string', 'string', 'string', 'string'];
  displayEndPoint = [];
  users: any = [];
  selectUserOptions = new SelectUserOptions();
  allFilters = FilterUtil.UserSelectFilter;
  filters: any = {};

  constructor(injector: Injector, private matDialogRef: MatDialogRef<SelectUserComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getUsers(this.tableProperties.offset, this.tableProperties.limit, 'UserExtraAttributes,UserExtraAttributes.Attribute', RequestType.PAGINATE, {
      Filter: this.filters
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.users = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onLookUpSelected(option: any) {
    this.selectUserOptions.onUserSelected(option);
    this.noAction();
  }

  noAction() {
    this.matDialogRef.close();
  }

  protected override setListeners() {
    super.setListeners();
    for (let i = 0; i < this.users.length; i++) {
      this.users[i].touch_app = (index: number) => {
        this.onLookUpSelected(index);
      };
    }
  }
}
